import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2WorldSelectionDialogProperties extends BasicDialogProperties {
    constructor() {
        super();
    }
}
